import { getTermsValue, resetTerms, setTerms } from '../../../../JsonQuery';
import { TTagsManager } from '../../types/tag';
import { createTagValue } from '../../utils/createTagValue';
import { EHouseLineType } from '../../../../api-models/common/json_query';

const ID = 'buildingHouseLine' as const;

const HOUSE_LINE_MAP_VALUE_TO_LABEL: Record<EHouseLineType, string> = {
  [EHouseLineType.First]: 'Первая линия',
  [EHouseLineType.Second]: 'Вторая линия',
};

export const buildingHouseLineTagsManager: TTagsManager = {
  id: ID,
  extractTagsFromJsonQuery: ({ jsonQuery }) => {
    const lines = getTermsValue('building_house_line_type__shopping_area')(jsonQuery);

    if (lines === null) {
      return null;
    }

    return lines.map(line => ({
      label: HOUSE_LINE_MAP_VALUE_TO_LABEL[line],
      value: createTagValue(ID, line.toString()),
    }));
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery, removingTagValue }) => {
    const lines = getTermsValue('building_house_line_type__shopping_area')(jsonQuery);

    if (lines === null) {
      return jsonQuery;
    }

    const next = lines.filter(line => String(line) !== removingTagValue);

    return next.length > 0
      ? setTerms('building_house_line_type__shopping_area')(jsonQuery)(next)
      : resetTerms(['building_house_line_type__shopping_area'])(jsonQuery);
  },
};
